import {
  PageBackgroundImage,
  ReferralWinner,
  Ticket,
  WinChance,
} from "../../../assets";
import theme from "../../../theme/Theme";

const styles = {
  pageBgImage: {
    position: "absolute",
    backgroundColor: "#fcfcfe",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556l-1.414-1.414L28 0h4zM.284 0l28 28-1.414 1.414L0 2.544V0h.284zM0 5.373l25.456 25.455-1.414 1.415L0 8.2V5.374zm0 5.656l22.627 22.627-1.414 1.414L0 13.86v-2.83zm0 5.656l19.8 19.8-1.415 1.413L0 19.514v-2.83zm0 5.657l16.97 16.97-1.414 1.415L0 25.172v-2.83zM0 28l14.142 14.142-1.414 1.414L0 30.828V28zm0 5.657L11.314 44.97 9.9 46.386l-9.9-9.9v-2.828zm0 5.657L8.485 47.8 7.07 49.212 0 42.143v-2.83zm0 5.657l5.657 5.657-1.414 1.415L0 47.8v-2.83zm0 5.657l2.828 2.83-1.414 1.413L0 53.456v-2.83zM54.627 60L30 35.373 5.373 60H8.2L30 38.2 51.8 60h2.827zm-5.656 0L30 41.03 11.03 60h2.828L30 43.858 46.142 60h2.83zm-5.656 0L30 46.686 16.686 60h2.83L30 49.515 40.485 60h2.83zm-5.657 0L30 52.343 22.343 60h2.83L30 55.172 34.828 60h2.83zM32 60l-2-2-2 2h4zM59.716 0l-28 28 1.414 1.414L60 2.544V0h-.284zM60 5.373L34.544 30.828l1.414 1.415L60 8.2V5.374zm0 5.656L37.373 33.656l1.414 1.414L60 13.86v-2.83zm0 5.656l-19.8 19.8 1.415 1.413L60 19.514v-2.83zm0 5.657l-16.97 16.97 1.414 1.415L60 25.172v-2.83zM60 28L45.858 42.142l1.414 1.414L60 30.828V28zm0 5.657L48.686 44.97l1.415 1.415 9.9-9.9v-2.828zm0 5.657L51.515 47.8l1.414 1.413 7.07-7.07v-2.83zm0 5.657l-5.657 5.657 1.414 1.415L60 47.8v-2.83zm0 5.657l-2.828 2.83 1.414 1.413L60 53.456v-2.83zM39.9 16.385l1.414-1.414L30 3.658 18.686 14.97l1.415 1.415 9.9-9.9 9.9 9.9zm-2.83 2.828l1.415-1.414L30 9.313 21.515 17.8l1.414 1.413 7.07-7.07 7.07 7.07zm-2.827 2.83l1.414-1.416L30 14.97l-5.657 5.657 1.414 1.415L30 17.8l4.243 4.242zm-2.83 2.827l1.415-1.414L30 20.626l-2.828 2.83 1.414 1.414L30 23.456l1.414 1.414zM56.87 59.414L58.284 58 30 29.716 1.716 58l1.414 1.414L30 32.544l26.87 26.87z' fill='%23f2f2f2' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E\")",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    width: "100vw",
    height: "100%",
  },
  bannerImageView: {
    position: "absolute",
    aspectRatio: { xs: "5/2", sm: "5/2", md: "14/2" },
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    zIndex: -1,
  },
  bannerImage: {
    position: "relative",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    color: "white",
    py: 4,
    zIndex: 1,
  },
  bannerContent: {
    padding: { xs: "0 1.2em", lg: "0 2em" },
  },
  drawBgImage: {
    background: `url(${PageBackgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100vw",
  },
  pageContent: {
    padding: { xs: "1em 1em", lg: "1em 2em" },
  },
  bannerTitle: {
    fontSize: { xs: "6vw", lg: "2vw" },
    fontWeight: 600,
    color: "rgba(0, 0, 0, 0.75)",
    textTransform: "uppercase",
  },
  bannerSubTitle: {
    fontSize: { xs: "8vw", lg: "4vw" },
    fontWeight: 700,
    color: "rgba(0, 0, 0, 0.75)",
    lineHeight: 1,
  },
  letsJoinText: {
    fontSize: { xs: "5vw", lg: "3vw" },
    fontWeight: 800,
    color: "rgba(0, 0, 0, 1)",
    lineHeight: 1,
  },
  letsJoinTextHighlight: {
    color: theme.palette.primary.main,
  },
  drawTitleTicket: {
    display: "flex",
    flexDirection: { xs: "column", sm: "column", md: "row" },
    alignItems: { xs: "flex-start", sm: "flex-start", md: "center" },
    justifyContent: { xs: "flex-start", sm: "flex-start", md: "space-between" },
    width: "100%",
    padding: { xs: 0, md: "0 2em", lg: "0 2em" },
    gap: { xs: 2, md: 0, lg: 0 },
  },
  drawNumber: {
    background: `linear-gradient(307deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 87%, ${theme.palette.primary.main} 100%)`,
    padding: { xs: "0.2em", lg: "1em 2em" },
    borderRadius: "1em",
    border: `0.75px solid ${theme.palette.primary.main}`,
    boxShadow: "rgba(255, 128, 128, 0.38) 0px 7px 29px 0px",
  },
  drawNumberText: {
    fontSize: { xs: "3vw", lg: "1.3vw" },
    color: "rgba(255, 255, 255, 1)",
    fontWeight: 600,
    textTransform: "uppercase",
    lineHeight: 1,
    textAlign: "center",
  },
  crownImage: {
    width: "2em",
    height: "1.4em",
  },
  crownSMImage: {
    width: "1.2em",
    height: "1em",
  },
  ticketContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: { xs: "100%", md: "0 auto", lg: "0 auto" },
    marginTop: { xs: "1em", md: "2em", lg: "2em" },
  },
  ticketCard: {
    background: `url(${Ticket})`,
    position: "relative",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    width: { xs: "100%", md: "50%", lg: "55%" },
  },
  ticketLogoImage: {
    position: "absolute",
    bottom: { xs: 10, lg: 14 },
    left: "50%",
    transform: "translateX(-50%)",
    width: "60%",
    zIndex: 0,
  },
  tickerContent: {
    padding: { xs: 4, sm: 4, md: 2, lg: 8 },
  },

  daysStartEndText: {
    fontSize: { xs: "3vw", lg: "0.9vw" },
    fontWeight: 500,
    color: "#1F1F1F",
    lineHeight: 1.4,
    textTransform: "uppercase",
  },
  daysStartEndTextHighlight: {
    fontSize: { xs: "2.5vw", lg: "1vw" },
    fontWeight: 600,
    color: "#1F1F1F",
    borderRadius: "2em",
    textAlign: "center",
  },
  perEntrySmallText: {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "rgba(0, 0, 0, 1)",
    lineHeight: 1,
  },
  perEntryText: {
    fontSize: { xs: "0.9rem", lg: "1.5rem" },
    fontWeight: 700,
    color: "rgba(0, 0, 0, 1)",
    lineHeight: 1,
    textTransform: "uppercase",
  },
  ticketValues: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: "rgba(82, 82, 82, 1)",
    lineHeight: 1,
  },
  totalTicketValues: {
    fontSize: { xs: "0.8rem", lg: "1rem" },
    fontWeight: 600,
    color: "rgba(0, 0, 0, 1)",
    lineHeight: 1,
  },
  totalTicketValueText: {
    fontFamily: "Jura",
    fontSize: { xs: "1rem", lg: "1.5rem" },
    fontOpticalSizing: "auto",
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  progressBarContainer: {
    position: "relative",
    backgroundColor: "rgba(217, 217, 217, 1)",
    height: "8px",
    width: "100%",
    borderRadius: "10em",
    overflow: "hidden",
    margin: { xs: "2px 0 1px 0", lg: "6px 0" },
  },
  progressBar: {
    backgroundColor: "#0093E9",
    backgroundImage:
      "linear-gradient(90deg, #2AF598 0%, #eae608 31%, #fb9b03 65%, #ff0004 100%)",
    height: "8px",
    borderRadius: "10em",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
  },
  smartContractContainer: {
    ":hover": {
      cursor: "pointer",
    },
  },
  smartContractText: {
    fontSize: { xs: "0.65rem", sm: "0.8rem", lg: "0.9rem" },
    fontWeight: 700,
    color: "rgba(0, 87, 149, 1)",
    lineHeight: 1.5,
    textTransform: "uppercase",
  },
  purchaseButton: {
    backgroundColor: theme.palette.primary.main,
    color: "rgba(255, 255, 255, 1)",
    fontSize: { xs: "0.65rem", sm: "0.8rem", lg: "0.9rem" },
    fontWeight: "700",
    textTransform: "uppercase",
    marginTop: { xs: "1em", sm: "1em", lg: "2em" },
    marginBottom: "1em",
    marginRight: "2em",
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    borderRadius: "2em",
    "&:hover": {
      cursor: "pointer",
    },
  },
  titleText: {
    fontWeight: "800",
    fontSize: { xs: "1.1em", sm: "1.3em", md: "2.4rem", lg: "2.8rem" },
    textAlign: "center",
    color: "rgba(0, 0, 0, 1)",
    textTransform: "uppercase",
  },
  titleHighLight: {
    color: theme.palette.primary.main,
    borderBottom: "1.5px solid rgba(0, 0, 0, 1)",
  },
  daysRemaining: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: { xs: "1em", md: "3em", lg: "3em" },
  },
  daysRemainingTimeContainer: {
    backgroundColor: theme.palette.primary.main,
    color: "rgba(255, 255, 255, 1)",
    padding: { xs: "1em", lg: "1em 2.5em" },
    borderRadius: "15px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: { xs: 2, lg: 4 },
    marginTop: "1em",
  },
  daysRemainingTimeText: {
    fontSize: { xs: "2.5rem", lg: "3.5rem" },
    fontWeight: 600,
    lineHeight: 1,
  },
  daysRemainingTimeIcon: {
    fontSize: { xs: "0.8rem", lg: "1rem" },
    fontWeight: 700,
    lineHeight: 1,
    textAlign: "center",
  },
  winChanceContainer: {
    position: "relative",
    background: `url(${WinChance})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: { xs: "1em 1em", lg: "2em 3em" },
    marginTop: "2em",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  winChanceTextH3: {
    fontSize: { xs: "0.9rem", lg: "1.5rem" },
    fontWeight: 600,
    color: "rgba(255, 255, 255, 1)",
    lineHeight: 1,
    textTransform: "uppercase",
    textAlign: "right",
  },
  winChanceTextH2: {
    fontSize: { xs: "1.5rem", lg: "2.5rem" },
    fontWeight: 700,
    color: "rgba(255, 255, 255, 1)",
    lineHeight: 1,
    textTransform: "uppercase",
    textAlign: "right",
    marginTop: "10px",
  },
  winChanceTextH1: {
    fontSize: { xs: "1.8rem", lg: "3rem" },
    fontWeight: 700,
    color: "rgba(255, 255, 255, 1)",
    lineHeight: 1,
    textTransform: "uppercase",
    textAlign: "right",
    marginTop: "10px",
  },
  winChanceTextH1Highlight: {
    textShadow: "0 0 8px rgba(255, 101, 14, 1), 0 0 5px rgba(255, 101, 14, 1)",
  },
  participateNowButtonContainer: {
    background:
      "linear-gradient(90deg, rgba(231,76,53,1) 0%, rgba(191,21,34,1) 31%)",
    borderRadius: "5px",
    padding: "2px",
    marginTop: "10px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  participateNowButton: {
    borderRadius: "5px",
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(255, 101, 14, 1)",
  },
  participateNowButtonText: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "rgba(0, 0, 0, 1)",
    lineHeight: 1,
    textTransform: "uppercase",
    padding: "0.8em 1.4em",
  },
  topRewardsContainer: {
    position: "relative",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  topRewardsBg: {
    position: "absolute",
    clipPath:
      "polygon(100% 100%, 0% 100% , 0.00% 1.33%, 2.00% 1.36%, 4.00% 1.45%, 6.00% 1.60%, 8.00% 1.80%, 10.00% 2.06%, 12.00% 2.38%, 14.00% 2.75%, 16.00% 3.16%, 18.00% 3.63%, 20.00% 4.14%, 22.00% 4.69%, 24.00% 5.27%, 26.00% 5.89%, 28.00% 6.54%, 30.00% 7.21%, 32.00% 7.90%, 34.00% 8.61%, 36.00% 9.33%, 38.00% 10.05%, 40.00% 10.78%, 42.00% 11.50%, 44.00% 12.22%, 46.00% 12.92%, 48.00% 13.60%, 50.00% 14.26%, 52.00% 14.89%, 54.00% 15.49%, 56.00% 16.06%, 58.00% 16.59%, 60.00% 17.07%, 62.00% 17.51%, 64.00% 17.90%, 66.00% 18.24%, 68.00% 18.53%, 70.00% 18.76%, 72.00% 18.93%, 74.00% 19.05%, 76.00% 19.10%, 78.00% 19.10%, 80.00% 19.04%, 82.00% 18.92%, 84.00% 18.74%, 86.00% 18.51%, 88.00% 18.22%, 90.00% 17.87%, 92.00% 17.48%, 94.00% 17.04%, 96.00% 16.55%, 98.00% 16.02%, 100.00% 15.45%)",
    background: `linear-gradient(325deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 87%, ${theme.custom.primaryDarker} 100%)`,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  topRewards: {
    position: "relative",
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "rgba(120, 13, 13, 0.38) 0px 3px 8px",
    borderRadius: "1em",
    width: { xs: "calc(100%)", sm: "calc(100%)", lg: "calc(100% - 6em)" },
    backgroundColor: "rgba(255, 255, 255, 1)",
    top: { xs: 40, lg: "8em" },
    left: { xs: 0, lg: "6em" },
    transform: { xs: "translateX(0)", lg: "translateX(-6em)" },
  },

  topRewardsTitle: {
    backgroundColor: theme.palette.primary.main,
    padding: "0.5em 1em",
    borderRadius: "10px",
    position: "absolute",
    margin: "0 auto",
    left: "50%",
    top: "-0.7em",
    transform: "translateX(-50%)",
  },
  topRewardsTitleText: {
    color: "rgba(0, 0, 0, 1)",
    fontSize: { xs: "3vw", lg: "1.5vw" },
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase",
  },
  topRewardsTitleHighlight: {
    color: "rgba(255, 255, 255, 1)",
  },
  rewardCrownBox: {
    position: "relative",
  },
  rewardRankRing: {
    position: "absolute",
    height: { xs: "3em", lg: "3.1em" },
    width: { xs: "3em", lg: "3.1em" },
    border: "3px solid rgba(255, 101, 14, 1)",
    borderRadius: "50%",
    transform: { xs: "translate(15%, -45%)", lg: "translate(9%, -30%)" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 1)",
    zIndex: 1,
  },
  rewardRankText: {
    fontSize: { xs: "6vw", lg: "3vw" },
    fontWeight: 700,
    lineHeight: 1,
  },
  rewardAmountContainer: {
    position: "absolute",
    background: `linear-gradient(142deg, ${theme.custom.primaryDarker} 0%, ${theme.palette.primary.dark} 25%,${theme.palette.primary.main} 50%, ${theme.palette.primary.light} 75%, ${theme.palette.primary.dark} 100%)`,
    borderRadius: "10px",
    width: { xs: "10em", lg: "8em" },
    height: { xs: "2em", lg: "2.2em" },
    transform: { xs: "translate(20%, -30%)", lg: "translate(20%, -15%)" },
    display: "flex",
    alignItems: "center",
  },
  rewardAmountText: {
    color: "rgba(255, 255, 255, 1)",
    fontSize: { xs: "3vw", lg: "1.5vw" },
    fontWeight: 600,
    lineHeight: 1,
    textTransform: "uppercase",
    paddingLeft: { xs: "15vw", lg: "4.2vw" },
  },
  referralLevelsTableTitleText: {
    color: "rgb(24, 24, 24)",
    fontSize: { xs: "4vw", lg: "2.6vw" },
    fontWeight: 700,
    marginBottom: "0.6em",
  },
  tableHeadText: {
    color: "rgb(24, 24, 24)",
    fontSize: { xs: "3vw", lg: "1vw" },
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase",
  },
  tableCellText: {
    color: "rgb(78, 78, 78)",
    fontSize: { xs: "2.6vw", lg: "1vw" },
    fontWeight: 600,
    lineHeight: 1,
    textTransform: "uppercase",
  },
  tableReferralHeadText: {
    color: "rgb(255, 255, 255)",
    fontSize: { xs: "3vw", lg: "1vw" },
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase",
  },
  trophyCupImageSm: {
    width: "2.2em",
    objectFit: "contain",
  },
  trophyCupImage: {
    width: "6em",
    objectFit: "contain",
  },
  probabilityTitleText: {
    fontSize: { xs: "0.8rem", lg: "1.9rem" },
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 1)",
  },
  probabilityValueText: {
    fontSize: { xs: "1.6rem", lg: "4.6rem" },
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase",
    color: theme.palette.primary.main,
  },
  disclaimerLink: {
    color: "rgba(255, 255, 255, 1)",
    textAlign: "center",
    fontWeight: 600,
    fontSize: { xs: "1.1rem", lg: "1.2rem" },
    width: { xs: "90%", lg: "70%" },
    margin: "3em auto",
    textDecoration: "underline",
    fontStyle: "italic",
  },
  winProbabilityContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: "1em",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    padding: { xs: "0.8em 1em", lg: "1em 1.5em" },
    border: `1px solid ${theme.palette.primary.main}`,
    marginTop: { xs: "3em", lg: "10em" },
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: { xs: 3, lg: 6 },
    zIndex: 1,
  },
  declaimerText: {
    color: "rgba(255, 255, 255, 1)",
    textAlign: "center",
    fontWeight: 500,
    fontSize: { xs: "1rem", lg: "1.2rem" },
    width: { xs: "90%", lg: "70%" },
    margin: "3em auto",
    zIndex: 2,
  },
  referralButtonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "1em",
  },
  referralButtonStyle: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    color: theme.palette.primary.main,
    padding: "0.5em 1em",
    borderRadius: "10px",
    fontSize: "1.2rem",
    fontWeight: 700,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5em",
  },
  referralWinnerContainer: {
    marginTop: "2em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: { xs: "100vw", md: "70%" },
    justifyContent: "center",
  },
  referralWinnerBg: {
    background: `url(${ReferralWinner})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "100% 100%", lg: "100% 100%" },
    width: { xs: "90vw", md: "70%", lg: "90%" },
    position: "relative",
  },
  referralTextContainer: {
    paddingLeft: { xs: "1.4rem", md: "1.5em", lg: "1.5em" },
    paddingTop: { xs: "2.8rem", md: "4.5em", lg: "4.5em" },
    paddingBottom: { xs: "3em", md: "4em", lg: "4em" },
  },
  referralText: {
    color: "rgba(255, 255, 255, 1)",
    fontSize: { xs: "1.4rem", lg: "2.6rem" },
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase",
  },
  referralButton: {
    position: "absolute",
    left: { xs: "50%", lg: "70%" },
    top: { xs: "40%", lg: "50%" },
    transform: "translate(-10%, 80%)",
    backgroundColor: "rgba(255, 255, 255, 1)",
    color: theme.palette.primary.main,
    padding: "0.5em 1em",
    borderRadius: "10px",
    fontSize: { xs: "1rem", lg: "1.2rem" },
    fontWeight: 700,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5em",
  },
  winProbabilityBox: {
    position: "relative",
    width: "100vw",
    padding: { xs: "1em 1em", lg: "2em 1em 3em 1em" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
  quantityFieldStyle: {
    width: "120px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none", // Remove the border
    },
    "& .MuiInputBase-input": {
      backgroundColor: "transparent",
      color: "#000000",
      fontSize: "1rem",
      fontWeight: 600,
      textAlign: "center",
      borderRadius: "50px",
      padding: "0em 0em",
    },
  },
  quantityFieldMinusIconStyle: {
    color: "#fff",
    backgroundColor: "#393939",
    marginRight: "5px",
    padding: "5px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,1)",
    },
  },
  quantityFieldPlusIconStyle: {
    color: "#fff",
    backgroundColor: "#393939",
    marginLeft: "5px",
    padding: "5px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,1)",
    },
  },
  referralTableContainer: {
    borderRadius: "0.4em",
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.main,
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  noDrawFoundContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "3em",
    marginBottom: "3em",
  },
  noDrawFoundImg: {
    width: { xs: "60%", lg: "30%" },
  },
  noDrawFoundText: {
    fontSize: { xs: "1rem", lg: "1.4rem" },
    fontWeight: 600,
    color: "#3F3F42",
    lineHeight: 1.2,
  },
};
export default styles;
